// extracted by mini-css-extract-plugin
export default {"generalPerformance":"general-performance_generalPerformance__l6pAH","controls":"general-performance_controls__JH1Ds"};